import { render, staticRenderFns } from "./seguro-empate-mark.vue?vue&type=template&id=c4d78efe&scoped=true&"
import script from "./seguro-empate-mark.vue?vue&type=script&lang=js&"
export * from "./seguro-empate-mark.vue?vue&type=script&lang=js&"
import style0 from "./seguro-empate-mark.vue?vue&type=style&index=0&id=c4d78efe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4d78efe",
  null
  
)

export default component.exports